import { __assign, __makeTemplateObject, __rest } from "tslib";
import { Grommet } from 'grommet';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import * as React from 'react';
import styled from 'styled-components';
import defaultTheme from '../../theme';
import { px } from '../../utils';
import { BreakpointProvider } from './BreakpointProvider';
import { Helmet } from 'react-helmet';
var Base = styled(Grommet)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tcolor: ", ";\n"], ["\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tcolor: ", ";\n"])), function (props) { return props.theme.font; }, function (props) { return px(props.theme.fontSizes[2]); }, function (props) { return px(props.theme.colors.text.main); });
var BaseProvider = function (_a) {
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    var isDefaultFont = !(theme === null || theme === void 0 ? void 0 : theme.font);
    var providerTheme = merge(cloneDeep(defaultTheme), theme);
    return (React.createElement(BreakpointProvider, { breakpoints: providerTheme.breakpoints },
        isDefaultFont && (React.createElement(Helmet, null,
            React.createElement("link", { href: "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,400;0,600;1,400&family=Ubuntu+Mono:wght@400;700&display=fallback", rel: "stylesheet" }))),
        React.createElement(Base, __assign({ theme: providerTheme }, props))));
};
export var Provider = BaseProvider;
var templateObject_1;
